<button (click)="togglePopup()" class="fr button" id="feedback">
  <i class="far icon-win fa-comment"></i>
</button>

<div class="popup" *ngIf="popupVisible">
  <div class="popup-content">
    <h2>Feedback Form</h2>
    <form (submit)="submitFeedback($event)">
      <app-field-wrapper labelsWidth="110px">
        <w-textarea-field label="Feedback: " rowSpan="3" [(value)]="feedback"></w-textarea-field>
      </app-field-wrapper>

      <div class="text-right">
        <w-button type="submit" label="Send">Send</w-button>
      </div>
      <i (click)="closePopup()" class="close-button fas fa-xmark"></i>
    </form>
  </div>
</div>
